import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = async () => {
        const token = localStorage.getItem("clonzo_token");
        if (!token) { setUser(null); setLoading(false); return; }
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch {
            localStorage.removeItem("clonzo_token");
            setUser(null);
        } finally { setLoading(false); }
    };

    useEffect(() => { refresh(); }, []);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        localStorage.setItem("clonzo_token", data.token);
        setUser(data.user);
        return data.user;
    };
    const signup = async (payload) => {
        const { data } = await api.post("/auth/register", payload);
        localStorage.setItem("clonzo_token", data.token);
        setUser(data.user);
        return data.user;
    };
    const logout = () => {
        localStorage.removeItem("clonzo_token");
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, signup, logout, refresh }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
